import { instance3 } from "App/constants";

export const urlGet = "/master/template/list";
export const urlCreate = "/master/template/add";
export const urlUpdate = "/master/template/update";

export const urlDelete = "/master/template/delete";
export const urlGetById = "/master/rikjang/ms_rikjang/detailsById";

export const urlAddItem = "/master/template/addItem";
export const urlDeleteItem = "/master/template/deleteItem";

export const urlGetUnit = "/wmsfarmasi/master/masterUnit/list";

export const RESET_STATE_TEMPLATE = {
  nama: "",
  unit_id: null,
  unit_name: "Pilih Unit",
  status: 1,
  barang: [],
  jasa: [],
  fasilitas: [],
  rikjang: [],
  remark: "",
};

export const RESET_STATE_FILTER_TEMPLATE = {
  unit_id: null,
  unit_name: "Pilih Unit",
  nama: "",
  id: "",
  pages: 1,
  limit: 10,
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "5%",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "5%",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_unit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const getByFilterTemplate = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post(urlGet, {
      id: formFilter.id,
      id_unit: formFilter.unit_id,
      halaman: pages,
      jumlah: limit,
      nama: formFilter.nama,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getItemByTemplateID = async (url, id) => {
  try {
    const api = await instance3.get(`${url}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteItemById = async (id) => {
  try {
    const res = await instance3.post(urlDeleteItem, {
      id,
    });
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const addItemById = async (formData) => {
  try {
    const res = await instance3.post(urlAddItem, {
      id_template: formData.id_template,
      item_type: formData.item_type,
      item_id: formData.item_id,
      qty: formData.qty,
    });
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menambah data",
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteTemplateById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, {
      id_template: id,
    });

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
